/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import Swiper, { Navigation, Pagination, EffectFade, Autoplay, Lazy } from 'swiper';
Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Lazy]);

// Import from node-module
import '@fortawesome/fontawesome-free/js/all.min';

$(document).ready(() => {
  // eslint-disable-next-line no-unused-vars, no-undef
  var mySwiper = new Swiper('.swiper-container', {
    // Optional parameters
    autoplay: {
      delay: 5000,
    },
    speed: 2500,
    effect: 'fade',
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
    centeredSlides: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  var $hamburger = $(".hamburger");
  // eslint-disable-next-line no-unused-vars, no-undef
  $hamburger.on("click", function(e) {
    $hamburger.toggleClass("is-active");
    $('#menu').toggleClass('open');
  });

  $('span.sf-count').text(function(_, text) {
    return text.replace(/\(|\)/g, '');
  });

  // Contactform7 validation add required
  $('.wpcf7-validates-as-required').attr('required', true);
  $('.wpcf7-checkbox > .wpcf7-list-item, .wpcf7-radio > .wpcf7-list-item')
    .addClass('btn-group-toggle')
    .attr('data-toggle', 'buttons');
  $('.wpcf7-form input[type=checkbox], .wpcf7-form input[type=radio]')
    .closest('label')
    .addClass('btn btn-secondary');
  $('label.btn.active')
    .removeClass('btn-secondary')
    .addClass('btn-success');
  $('.wpcf7-list-item-label').on('click', function () {
    if ($(this).parent().hasClass('active')) {
       $(this).parent().removeClass('active');
    } else {
      $(this).parent().addClass('active');
    }
  });

  // Starter JavaScript for disabling form submissions if there are invalid fields
  (function() {
    'use strict';
    window.addEventListener(
      'load',
      function() {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('bs4-validation');
        // Loop over them and prevent submission
        // eslint-disable-next-line no-unused-vars
        var validation = Array.prototype.filter.call(forms, function(form) {
          form.addEventListener(
            'submit',
            function(event) {
              if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
              }
              form.classList.add('was-validated');
            },
            false
          );
        });
      },
      false
    );
  })();
});

$(document).on("sf:init", ".searchandfilter", function(){
	 // eslint-disable-next-line no-unused-vars, no-undef
  var macyItem = Macy({
    container: '#macy-container-item',
    trueOrder: true,
    waitForImages: false,
    margin: 24,
    columns: 4,
    breakAt: {
      1200: 4,
      940: 3,
      520: 2,
      400: 1,
    },
  });

  macyItem.runOnImageLoad(function () {
    const div = document.getElementById('macy-container-item');
    div.classList.add('showfade');
    macyItem.recalculate(true, true);
  });
});

$(document).ajaxStop(function() {
  $('span.sf-count').text(function(_, text) {
    return text.replace(/\(|\)/g, '');
  });
});
